import { useWizard } from "react-use-wizard";
import buySteps from "../buySteps";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../..";
import { EPurchasePurpose } from "../../../../../../shared/wizard/steps/types";
import AimStep from "../../../../../../shared/wizard/steps/aimStep";

interface IWishStep_7 {
  isNextStepDisabled: boolean;
  onChange: (
    data: EPurchasePurpose,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void;
  data: EPurchasePurpose | null;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const WishStep_7 = ({
  isNextStepDisabled,
  data,
  onChange,
  onReset,
}: IWishStep_7) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.step_6);
    onReset(["aim"]);
  };

  const handleNextStep = () => {
    goToStep(buySteps.wishesSteps.step_8);
  };

  return (
    <div>
      <AimStep
        onNexStep={handleNextStep}
        onPrevStep={handlePrevStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
      />
    </div>
  );
};

export default WishStep_7;
